import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudBaseService } from '../crud.service';

@Injectable()

export class FingerprintService extends CrudBaseService<any> {

    constructor(
        httpClient: HttpClient
    ) {
        super('/watchdog/fingerprint', httpClient);
    }
}
